import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

import { IconCircleInfoFilled } from '~shared-components/icons/brand/IconCircleInfoFilled'

import { useTranslations } from '../../hooks/useTranslations'

export const NoPriceAvailable = () => {
  const t = useTranslations()

  return (
    <Flex alignItems="center">
      <IconCircleInfoFilled boxSize="20px" color="neutral.50" />
      <Text color="neutral.50" ml={1.5}>
        {t('label.nopriceavailable')}
      </Text>
    </Flex>
  )
}
